<button
  *ngIf="!linkHref"
  [attr.aria-label]="ariaLabel"
  [disabled]="disabled"
  [ngClass]="iconButtonClasses"
  [type]="typeAttribute"
  (click)="onClick($event)"
>
  <iris-icon
    [name]="icon"
    (click)="onClick($event)"
    [size]="iconSize"
  ></iris-icon>
</button>

<!-- link icon button -->
<a
  *ngIf="linkHref && !disabled"
  [attr.href]="linkHref"
  [attr.target]="target"
  [ngClass]="iconButtonClasses"
  (click)="onClick($event)"
  role="button"
>
  <iris-icon
    [name]="icon"
    (click)="onClick($event)"
    [size]="iconSize"
  ></iris-icon>
</a>

<!-- link icon button disabled -->
<a
  *ngIf="linkHref && disabled"
  [ngClass]="[iconButtonClasses, 'link-disabled']"
  role="button"
>
  <iris-icon [name]="icon" [size]="iconSize"></iris-icon>
</a>
